// src/components/directory/ListingCard.js

import React from 'react';
import { Link } from 'react-router-dom'; // Link import edildi

const ListingCard = ({ listing }) => {
    return (
        // Kartın tamamını bir Link bileşeni ile sarmalıyoruz
        <Link to={`/directory/${listing.id}`} className="text-decoration-none text-dark">
            <div className="card h-100 shadow-sm directory-card"> 
                <div className="row g-0">
                    <div className="col-4 d-flex align-items-center justify-content-center p-3">
                        <img 
                            src={listing.photoURL || 'https://via.placeholder.com/150'} 
                            className="img-fluid rounded-circle" 
                            alt={`${listing.name} logo`}
                            style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                        />
                    </div>
                    <div className="col-8">
                        <div className="card-body">
                            <h5 className="card-title fw-bold mb-1">{listing.name}</h5>
                            <p className="card-text small text-secondary mt-2">{listing.description}</p>
                        </div>
                    </div>
                </div>
                {/* Kartın köşesine "View Profile" ikonu ekliyoruz */}
                <div className="position-absolute top-0 end-0 p-2">
                    <i className="bi bi-box-arrow-up-right text-primary"></i>
                </div>
            </div>
        </Link>
    );
};

export default ListingCard;